export const determineNotificationType = (iconObj) => {
    let notificationType = iconObj.iconName;
    if (iconObj.additionalInfo){
        let additionalInfo = iconObj.additionalInfo;
        if (additionalInfo.unlockedFeature === true){
            if (+additionalInfo.level === 1){
                notificationType += "Unlocked";
            }else{
                notificationType += "NewLevel";
            }
        }
    }
    return notificationType;
}
export default determineNotificationType;